// TX-readiness helpers for episode dropdowns.
// "Ready" = approved/staged in the unified workflow OR a TX file path exists.
// Native <option> elements strip HTML styling, so we return an emoji prefix.

export function isEpisodeTxReady (episode) {
  if (!episode) return false
  const status = episode.tx_workflow_status
  if (status === 'approved' || status === 'staged') return true
  return !!(
    episode.stitched_file_path?.trim() ||
    episode.transcoded_file_path?.trim() ||
    episode.storage_path?.trim()
  )
}

export function episodeStatusDot (episode) {
  return isEpisodeTxReady(episode) ? '🟢' : '🔴'
}
